<div *ngIf="isActive">
  <i
    class="cc-icon cc-icon-arrow-long-up arrow-icon"
    ngbPopover="A-Z"
    popoverClass="popover-user-list-sorting"
    triggers="mouseenter:mouseleave"
    placement="bottom"
    *ngIf="currentSortOrder === sortOrder.ASC"
  ></i>
  <i
    class="cc-icon cc-icon-arrow-long-down arrow-icon"
    ngbPopover="Z-A"
    popoverClass="popover-user-list-sorting"
    triggers="mouseenter:mouseleave"
    placement="bottom"
    *ngIf="currentSortOrder === sortOrder.DESC"
  ></i>
</div>

<i *ngIf="!isActive" class="cc-icon cc-icon-arrow-long-down arrow-icon sm-text-grey-5"></i>
